/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * The action taken at this point in history
 */
export enum BlockHistoryEntryAction {
  blocked = 'blocked',
  unblocked = 'unblocked'
}
